<template>
    <div class="quote-container">
      <div class="quote-text">
        <slot></slot>
      </div>
      <a 
        :href="url" 
        target="_blank" 
        rel="noopener noreferrer" 
        class="quote-attribution"
      >
        <div class="quote-logo">
          <slot name="logo"></slot>
        </div>
        <div class="quote-details">
          <div class="quote-title">{{ title }}</div>
          <div class="quote-byline">
            by <span class="quote-author">{{ author }}</span> ({{ year }})
          </div>
        </div>
      </a>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Quote',
    props: {
      title: {
        type: String,
        required: true
      },
      author: {
        type: String,
        required: true
      },
      year: {
        type: [String, Number],
        required: true
      },
      url: {
        type: String,
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  .quote-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 1.6rem;
    box-sizing: border-box;
    border-left: 1px solid #4A4A4A;
  }
  
  .quote-text {
    font-family: "Untitled Sans", sans-serif;
    font-size: 1.6rem;
    line-height: 1.3;
    letter-spacing: 0;
    color: #C0C0C0;
  }
  
  .quote-attribution {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    text-decoration: none;
    color: #C0C0C0;
    transition: color 0.2s ease;
  }
  
  .quote-attribution:hover {
    /* color: #FFFFFF; */
  }
  
  .quote-attribution:hover .quote-author {
    color: #FFFFFF;
  }
  
  .quote-logo {
    width: 4rem;
    height: 4rem;
    background-color: #323232;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ::v-deep .quote-logo img {
    width: 60%;
    transform-origin: center center;
    transition: transform 0.2s ease-in-out;
  }

  ::v-deep .quote-attribution:hover .quote-logo img {
    transform: scale(1.1);
  }
  
  .quote-details {
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;
    line-height: 1.3;
    letter-spacing: 0;
  }
  
  .quote-title {
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.3;
    font-style: italic;
  }
  
  .quote-byline {
    font-size: 1.6rem;
    line-height: 1.3;
  }
  
  .quote-author {
    text-decoration: underline;
    transition: all 0.2s ease-in-out;
  }
  </style>